import React from 'react';
import { useSpin } from '../../context/SpinContext';
import DropZone from './DropZone';
import { Slider } from '../ui/slider';

export default function ForegroundControls() {
  const { foreground, uploadForegroundImage, clearForegroundImage, updateForeground, errors } = useSpin();

  return (
    <div className="space-y-3">
      <p className="text-xs text-neutral-400 leading-relaxed">
        Add a transparent PNG — a logo, watermark, or track title — drawn on top of everything else.
      </p>
      <DropZone
        accept="image/png"
        hint="PNG with transparency"
        onFile={uploadForegroundImage}
        previewSrc={foreground.imageUrl}
        fileName={foreground.fileName}
        onClear={clearForegroundImage}
        error={errors.foreground}
      />

      {foreground.imageEl && (
        <div>
          <div className="flex items-center justify-between mb-2">
            <label className="block text-xs font-medium text-neutral-600">Size</label>
            <span className="text-xs text-neutral-400 font-mono" data-testid="foreground-scale-value">
              {Math.round(foreground.scale * 100)}%
            </span>
          </div>
          <Slider
            min={0}
            max={1.5}
            step={0.01}
            value={[foreground.scale]}
            onValueChange={(v) => updateForeground({ scale: v[0] })}
            data-testid="foreground-scale-slider"
          />
        </div>
      )}
    </div>
  );
}
